let isTracking = false;

/* ===== Escape de HTML =====
   Todo texto que vem de fora (o código digitado, o nome da transportadora e o
   histórico das transportadoras) passa por aqui antes de entrar no innerHTML.
   Sem isso, um link de rastreio com código malicioso executava script dentro
   de milie.com.br. */
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const codigo = urlParams.get('codigo');

    if (codigo && !isTracking) {
        document.getElementById('trackingCode').value = codigo;
        fetchTrackingInfo();
    }
});

async function fetchTrackingInfo() {
    if (isTracking) return;
    isTracking = true;

    const trackingCode = document.getElementById('trackingCode').value;

    if (trackingCode.length < 8) {
        alert('Insira um código válido.');
        isTracking = false;
        return;
    }

    const apiUrl = 'https://milieflow.zatres.workers.dev/api/rastreio/rastrear';
    const container = document.getElementById('trackingInfo');

    container.style.display = 'block';
    container.innerHTML = `<p style="font-size:18px;text-align:center;">🔍 Rastreando...</p>`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ codigo: trackingCode })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        displayTrackingInfo(data);

    } catch (error) {
        console.error('Erro ao buscar informações de rastreamento:', error);
        container.innerHTML = `<p>Erro ao buscar informações de rastreamento. Por favor, tente novamente.</p>`;
    } finally {
        isTracking = false;
    }
}

function displayTrackingInfo(data) {
    const container = document.getElementById('trackingInfo');
    const historico = Array.isArray(data.historico) ? data.historico : [];

    /* ===== Código não reconhecido =====
       O Milieflow devolve transportadora '-' quando o código não tem o formato
       de nenhuma transportadora da Milie (erro de digitação, código de outra
       loja). Em vez de "Transportadora: -" sem link, explica o que fazer. */

    if (!data.transportadora || data.transportadora === '-') {
        container.innerHTML = `
            <div style="font-size:18px;color:#0b3b3b;margin-bottom:10px;">
                Não reconhecemos o código <strong>${esc(data.codigo || '-')}</strong>
            </div>
            <p>
                Confira o código no e-mail ou na mensagem de envio do seu pedido e tente de novo.
                Se continuar sem aparecer, fale com a gente pelo WhatsApp (21) 99734-5158.
            </p>
        `;
        return;
    }

    /* ===== Nome amigável da transportadora ===== */

    let transportadoraLabel = data.transportadora || '-';

    if (data.transportadora === 'CorreiosByFrenet') {
        transportadoraLabel = 'Correios 🚛';

    } else if (data.transportadora === 'LoggiByFrenet') {
        transportadoraLabel = 'Loggi 🚛';

    } else if (data.transportadora === 'JT Express') {
        transportadoraLabel = 'JT Express 🚛';
    }

    /* ===== Previsão (somente Loggi e Correios diretos) ===== */

    let previsaoHtml = '';

    if (
        data.previsao &&
        (data.transportadora === 'Loggi' || data.transportadora === 'Correios')
    ) {
        previsaoHtml = `
            <div style="margin-top:8px;">
                Previsão:
                <strong>${esc(formatDateOnly(data.previsao))}</strong>
            </div>
        `;
    }

    /* ===== Mensagem especial Correios ===== */

    let mensagemCorreios = '';

    if (
        data.transportadora === 'Correios' &&
        historico.some(item =>
            item.descricao?.toLowerCase().includes('aguardando retirada')
        )
    ) {
        mensagemCorreios = `
            <div style="margin-top:20px;color:red;">
                <strong>
                    Clique <a href="https://rastreamento.correios.com.br/" target="_blank">aqui</a>
                    para verificar o local de retirada nos Correios.
                </strong>
            </div>
        `;
    }

    container.innerHTML = `
        <div style="font-size:18px;color:#0b3b3b;margin-bottom:10px;">
            Consulta de rastreamento do código <strong>${esc(data.codigo || '-')}</strong>
        </div>

        <div>
            Transportadora:
            <strong>${esc(transportadoraLabel)}</strong>
        </div>

        ${previsaoHtml}
        ${mensagemCorreios}

        <div style="font-size:18px;color:#0b3b3b;margin-top:18px;">
            Histórico completo:
        </div>

        <ul id="historicoList"></ul>
        <div id="linkTransportadora" style="margin-top:20px;"></div>
    `;

    const historicoList = document.getElementById('historicoList');

    if (!historico.length) {
        historicoList.innerHTML = `
            <li>
                Por favor, clique no link abaixo para rastrear diretamente no site da transportadora.
            </li>
        `;

        renderLinkTransportadora(data.transportadora, data.codigo);
        return;
    }

    historicoList.innerHTML = historico.map(item => {
        let dataFormatada = '';
        let descricao = '';

        /* ===== Loggi ===== */

        if (data.transportadora === 'Loggi') {
            dataFormatada = formatDate(item.status?.updatedTime);

            const loc = [
                item.location?.city,
                item.location?.state
            ].filter(Boolean).join(', ');

            descricao = `${item.status?.highLevelStatus || ''}${loc ? `. ${loc}` : ''}`;

        /* ===== Correios ===== */

        } else if (data.transportadora === 'Correios') {
            dataFormatada = formatDateOnly(item.dtHrCriado);

            const loc = [
                item.unidade?.endereco?.cidade,
                item.unidade?.endereco?.uf
            ].filter(Boolean).join(', ');

            descricao = `${item.descricao || ''}${loc ? `, ${loc}` : ''}`;

        /* ===== Loggi e Correios via Frenet ===== */

        } else if (
            data.transportadora === 'LoggiByFrenet' ||
            data.transportadora === 'CorreiosByFrenet'
        ) {
            const d = parseBRDateTime(item.EventDateTime);

            dataFormatada = d ? formatDateFromDate(d) : '';

            const { city, state } = parseCityState(item.EventLocation);

            const loc = [city, state].filter(Boolean).join(', ');

            descricao = `${item.EventDescription || ''}${loc ? `. ${loc}` : ''}`;

        /* ===== JT Express ===== */

        } else if (data.transportadora === 'JT Express') {
            const d = parseISODateTime(item.EventDateTime);

            dataFormatada = d ? formatDateFromDate(d) : '';

            const { city, state } = parseCityState(item.EventLocation);

            const loc = [city, state].filter(Boolean).join(', ');

            descricao = `${item.EventDescription || ''}${loc ? `. ${loc}` : ''}`;

        /* ===== Outras ===== */

        } else {
            dataFormatada = formatDate(
                item.dataHora ||
                item.updatedTime ||
                item.dtHrCriado
            );

            descricao =
                item.ocorrencia ||
                item.descricao ||
                '';
        }

        return `<li>${esc(dataFormatada)} - ${esc(descricao)}</li>`;
    }).join('');

    renderLinkTransportadora(data.transportadora, data.codigo);
}


/* ===== Link da transportadora ===== */

function renderLinkTransportadora(transportadora, codigo) {
    const container = document.getElementById('linkTransportadora');
    let link = '';

    if (
        transportadora === 'Loggi' ||
        transportadora === 'LoggiByFrenet'
    ) {
        link = 'https://app.loggi.com/rastreador/completo';

    } else if (
        transportadora === 'Correios' ||
        transportadora === 'CorreiosByFrenet'
    ) {
        link = 'https://rastreamento.correios.com.br/';

    } else if (transportadora === 'Jadlog') {
        link = 'https://www.jadlog.com.br/jadlog/home';

    } else if (transportadora === 'JT Express') {
        link = `https://rastreio.frenet.com.br/JTE/${encodeURIComponent(codigo || '')}`;
    }

    if (link) {
        container.innerHTML = `
            <a href="${esc(link)}" target="_blank" rel="noopener noreferrer" style="font-weight:bold;color:#0b3b3b;">
                Clique aqui para rastrear no site da transportadora
            </a>
        `;
    }
}


/* ===== Helpers ===== */

function formatDate(dateTimeString) {
    const d = new Date(dateTimeString);

    if (isNaN(d)) return '';

    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function formatDateOnly(dateTimeString) {
    const d = new Date(dateTimeString);

    if (isNaN(d)) return '';

    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}


/* ===== Data Frenet: DD/MM/YYYY HH:mm ===== */

function parseBRDateTime(str) {
    if (!str) return null;

    const [date, time = '00:00'] = str.split(' ');
    const [dd, mm, yyyy] = date.split('/').map(Number);
    const [hh, min] = time.split(':').map(Number);

    return new Date(
        yyyy,
        mm - 1,
        dd,
        hh || 0,
        min || 0
    );
}


/* ===== Data JT Express: YYYY-MM-DD HH:mm:ss ===== */

function parseISODateTime(str) {
    if (!str) return null;

    const [date, time = '00:00:00'] = str.split(' ');

    const [yyyy, mm, dd] = date.split('-').map(Number);
    const [hh, min, sec] = time.split(':').map(Number);

    return new Date(
        yyyy,
        mm - 1,
        dd,
        hh || 0,
        min || 0,
        sec || 0
    );
}


function formatDateFromDate(d) {
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}


function parseCityState(str) {
    if (!str || str === '-') {
        return {
            city: '',
            state: ''
        };
    }

    const parts = str
        .split(/[-–—]/)
        .map(s => s.trim());

    return {
        city: parts[0],
        state: parts[1] || ''
    };
}


function pad(n) {
    return String(n).padStart(2, '0');
}
